/* unplugin-vue-components disabled */import script from "./FaqManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqManagement.vue?vue&type=script&setup=true&lang=js"

import "./FaqManagement.vue?vue&type=style&index=0&id=3ae69f95&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ae69f95"]])

export default __exports__